export const BRAND_URL = 'https://www.pixelpin.io';
